import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiBenefitsMutationRequest,
  PostApiBenefitsMutationResponse,
  PostApiBenefits401,
  PostApiBenefits403,
} from "../../../types/PostApiBenefits";

export function getPostApiBenefitsUrl() {
  return `/api/Benefits` as const;
}

/**
 * {@link /api/Benefits}
 */
export async function postApiBenefits(
  data?: PostApiBenefitsMutationRequest,
  config: Partial<RequestConfig<PostApiBenefitsMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiBenefitsMutationResponse,
    ResponseErrorConfig<PostApiBenefits401 | PostApiBenefits403>,
    PostApiBenefitsMutationRequest
  >({
    method: "POST",
    url: getPostApiBenefitsUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
